export const DEBT_STATUS = {
  OUTSTANDING: "outstanding",
  SETTLED: "settled",
  PARTIAL: "partial",
  DONE: "done",
} as const;

export const DEBT_STATUS_LABEL: Record<string, string> = {
  [DEBT_STATUS.OUTSTANDING]: "Chưa thanh toán",
  [DEBT_STATUS.SETTLED]: "Đã thanh toán đủ",
  [DEBT_STATUS.PARTIAL]: "Thanh toán một phần",
};

export const DEBT_STATUS_COLOR: Record<string, string> = {
  [DEBT_STATUS.OUTSTANDING]: "red",
  [DEBT_STATUS.SETTLED]: "green",
  [DEBT_STATUS.PARTIAL]: "orange",
};
